"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useMemo } from "react";
import { useLocalState } from "../use-local-state/use-local-state";
var INITIAL_RECENT_SEARCHES_STATE = {
    hotel: [],
    flight: [],
    car: [],
};
export function useRecentSearches(_a) {
    var type = _a.type;
    var _b = __read(useLocalState("travel__recent-searches", INITIAL_RECENT_SEARCHES_STATE), 2), state = _b[0], setState = _b[1];
    var searches = useMemo(function () {
        var recent = !type
            ? __spreadArray(__spreadArray(__spreadArray([], __read(state.hotel), false), __read(state.flight), false), __read(state.car), false) : state[type];
        return recent.sort(function (a, b) { return a.date.valueOf() - b.date.valueOf(); });
    }, [type, state]);
    return [searches, { add: add }];
    function add(location) {
        var _a;
        if (type) {
            setState(__assign(__assign({}, state), (_a = {}, _a[type] = updateRecentSearchList(location, state[type]), _a)));
        }
        else {
            console.error("useRecentSearches.add -> type is required");
        }
    }
}
function updateRecentSearchList(location, list) {
    var updatedList = __spreadArray([], __read(list), false);
    var existingMatchIndex = list.findIndex(function (search) { return search.location.id === location.id; });
    if (existingMatchIndex > -1) {
        updatedList.splice(existingMatchIndex, 1);
    }
    updatedList.unshift({
        date: new Date(),
        location: location,
    });
    return updatedList;
}
